// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__174yf","text":"SelectPayment_text__2iTRg","title":"SelectPayment_title__2Tu7N","btn":"SelectPayment_btn__ZdVVi"};